import React from 'react'
import * as Styled from './Header.styled'
import Logo from 'assets/images/tgaheader.png'

export interface GraphCard {
  date?: any
  title?: string
  count?: number // Eğer sağda sayı göstermek isterseniz
}

const Header: React.FunctionComponent<GraphCard> = ({ date, title, count }) => {
  const dates = new Date(date)
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }
  const formattedDate = dates.toLocaleDateString('tr-TR', options)

  return (
    <Styled.Container>
      <div id="card-box" className="header-logo-container">
        <img className="header-logo" src={Logo} alt="Logo" />
      </div>
      <div className="header-main-title">
        <h1 className="header-title">
          {title}
        </h1>
      </div>
      <div className="header-pager">
        <span className="header-pager-date">{formattedDate}</span>
      </div>
    </Styled.Container>
  )
}

export default Header
